module.exports = __webpack_public_path__ + "static/media/wavey.2900adf0.svg";